<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="just-in-case-foreign-passports">
<h1>14. Just-in-Case Foreign Passports</h1>
<p>I have regularly called my sister Ruth during the Second Intifada and asked her about the situation. On one of those calls, Ruth—a spirited and diligent graduate of Ben-Shemen Agricultural Boarding High School that responded, and so independently did Dudu, to the call of the charismatic leader and first prime-minister to settle the remote highlands of the Negev desert—answered my question with one word: “<em>Zift</em>!”</p>
<p>Ruth’s exceptional use of this Middle Eastern slang word for expressing disappointment parsimoniously conveyed to me that the tension between the Arab and Hebrew dwellers of Canaan reached an unbearable level and that the morale of the Hebrew dwellers was very low.</p>
<p>In response to my subsequent question on the general mood and morale, Ruth named many of our mutual Ashkenazi and half Ashkenazi acquaintances, including a retired Colonel, who had already used their entitlements and acquired, “just-in-case”, foreign passports from the eastern and central European countries of origin of their ancestors. The thought that one-third of our people had been massacred in those countries six decades ago passed through my mind.</p>
<p>I then asked my sister: “And what about you?”</p>
<p>My sister Ruth replied: “We, the Mizrachi Jews, cannot return to our ancestors’ countries of origin (Iran, Iraq, Lebanon, Syria, Yemen, Ethiopia, Egypt, Tunisia, Libya, Algeria and Morocco) and the rest of the world does not want us. We are the <em>bra’rah</em> (a slang word for low-quality fruits and vegetables). We are stuck.”</p>
<p>With the added periodical barrages of hundreds and thousands of rockets from Gaza and Lebanon on Hebrew cities and towns, the mood and morale of the ethnically, culturally, economically and politically polarised Modern Hebrew dwellers of the morally and environmentally decaying “Promised Land” have not improved and the aforesaid Ashkenazi-Mizrachi disparity in holding <em>just-in-case</em> foreign passports has not been diminished during the last twenty years that have passed from my quoted conversation with my sister Ruth.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch022.vue?bb6e1f8c